<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Active Applicant List">
      <template slot="actions">
        <vx-input-group class="mb-base">
          <vs-input class="w-full" placeholder="Enter Mobile No or Nid No" @keypress="onlyNumber"
                    v-model="searchParam"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" icon-pack="feather" icon="icon-search"
                         @click="serachActiveApplicant(searchParam)"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <!--      <vs-table stripe
                      :sst="true"
                      @search="handleSearch"
                      @change-page="handleChangePage"
                      @sort="handleSort"
                      v-model="selected"
                      :total="meta.total"
                      pagination
                      :max-items="meta.per_page"
                      search
                      :data="applicantList">-->
      <vs-table stripe
                :sst="true"
                @change-page="handleChangePage"
                v-model="selected"
                :total="meta.total"
                pagination
                :max-items="meta.per_page"
                :data="applicantList">
        <!--<template slot="header">
          <h3>
            All Applicant
          </h3>
        </template>-->
        <template slot="thead">
          <vs-th sort-key="name">
            Name
          </vs-th>
          <vs-th sort-key="phone">
            Mobile
          </vs-th>
          <vs-th sort-key="nid">
            Nid no
          </vs-th>
          <vs-th sort-key="status">
            Status
          </vs-th>
          <vs-th sort-key="status">
            Nid Validate Status
          </vs-th>
          <vs-th sort-key="id">
            Action
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{data[indextr].name}}
            </vs-td>

            <vs-td :data="data[indextr].ekyc.phone">
              {{data[indextr].ekyc.phone}}
              <div class="flex gap-3">
                <vs-button @click="showMbChangePopup(data[indextr].id, data[indextr].ekyc.phone)"
                           placeholder="Enter new mobile number" color="success" type="flat" size="small">change
                </vs-button>
                <vs-button @click="showPassresetPopup(data[indextr].id)"
                           placeholder="Enter new mobile number" color="success" type="flat" size="small">Reset Password
                </vs-button>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].ekyc.nid">
              {{data[indextr].ekyc.nid}}
            </vs-td>

            <vs-td :data="data[indextr].status">
              {{data[indextr].status==1?"Active":"Blacklist"}}
            </vs-td>

            <vs-td :data="data[indextr].ekyc.validate_by_nid">
              <vs-chip :color="data[indextr].ekyc.validate_by_nid === null?
              'warning':data[indextr].ekyc.validate_by_nid === 2?
                'primary': data[indextr].ekyc.validate_by_nid === 3?
              'danger':''">
              {{data[indextr].ekyc.validate_by_nid === null?
              'Not Validated':data[indextr].ekyc.validate_by_nid === 2?
                'Validated': data[indextr].ekyc.validate_by_nid === 3?
              'Blocked':''}}</vs-chip>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            class="clickable"/>
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2 clickable"/>-->
              <div class="demo-alignment">
                <feather-icon icon="EyeIcon" @click="applicantDetal(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
                <feather-icon color="danger" icon="UserXIcon" @click="block(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
                <feather-icon color="danger" icon="XIcon" @click="deleteUser(data[indextr])"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2 clickable"/>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <template lang="html">
      <div class="centerx">
        <vs-popup class="holamundo" title="Change Mobile Number" :active.sync="popupActivo">
          <vx-card>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/1 w-full mt-4">
                  <span>New Mobile No</span>
                </div>
                <div class="vx-col sm:w-1/1 w-full">
                  <vx-input-group class="mb-base">
                    <vs-input class="w-full" v-validate="'required|min:11|max:11'" data-vv-as="Mobile No"
                              @keypress="onlyNumber" v-model="mobile" name="mobile"/>
                    <span class="text-danger text-sm" v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="primary" @click="changeMobo(selectedId, mobile)">Change</vs-button>
                      </div>
                    </template>
                  </vx-input-group>
                  <!--                    <vs-input class="w-full" v-validate="'required|min:11|max:11'" data-vv-as="Mobile No" @keypress="onlyNumber"  v-model="mobile" name="mobile"/>-->
                  <!--                    <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>-->
                </div>
              </div>
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </template>
    <template lang="html">
      <div class="centerx">
        <vs-popup class="holamundo" title="Delete Confirmation!" :active.sync="popupActivForDelete">
          <vx-card>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/1 w-full mt-4">
                  <h5>Are you want to delete this user permanently?</h5>
                </div>
                <div class="vx-col sm:w-1/1 w-full">
                  <h4>User : {{selectedUser.name}}</h4>
                  <br>
                  <vs-button color="primary" @click="confirmDelete(selectedUser)">Delete</vs-button>

                </div>
              </div>
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </template>
    <template lang="html">
      <div class="centerx">
        <vs-popup class="holamundo" title="Password Reset!" :active.sync="popupActivForPassReset">
          <vx-card>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/1 w-full mt-4">
                  <h5>Are you want to reset password for this applicant?</h5>
                </div>
                <div class="vx-col sm:w-1/1 w-full">
                  <h4>Password reset with: 123456</h4>
                  <br>
                  <vs-button color="primary" @click="resetPassword(passResetId)">Reset</vs-button>

                </div>
              </div>
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </template>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import axios from "../../axios";

  export default {
    data() {
      return {
        selectedPgae: 1,
        searchParam: '',
        selected: [],
        popupActivo: false,
        popupActivForDelete: false,
        popupActivForPassReset: false,
        mobile: '',
        selectedId: '',
        passResetId: '',
        selectedUser: ''
      }
    },
    computed: {
      ...mapGetters(['applicantList', 'meta'])
    },
    mounted() {
      this.$store.dispatch('getApplicantList', 'applicants?status=1&page=' + this.selectedPgae);// '&search='
      console.log("Applicant=",this.applicantList);
    },
    watch: {
      searchParam(value) {
        if (value.length < 1) {
          this.$store.dispatch('getApplicantList', 'applicants?status=1&page=' + this.selectedPgae);
        }
      }
    },
    methods: {
      handleChangePage(page) {
        this.selectedPgae = page;
        this.$store.dispatch('getApplicantList', 'applicants?status=1&page=' + this.selectedPgae);
      },
      applicantDetal(id) {
        this.$router.push('/applicant-details/' + id).catch(() => {
        })
      },

      async block(id) {
        const blockUser = {
          id: id,
          data: {
            status: 0
          }
        };
        console.log("ID", id);
        await this.$store.dispatch('updateApplicant', blockUser);
        await this.$store.dispatch('getApplicantList', 'applicants?status=1&page=' + this.selectedPgae);
      },
      async resetPassword(id) {
        axios.post(`https://ho.butterflygroupbd.com/showroom-backend/api/passwordreset/${id}/reset-password`).then((response)=>{
          console.log("Password = ", response.data);
          this.popupActivForPassReset = false;
          if(response.status === 200){
            this.$vs.notify({
              title: 'Success',
              text: 'Successfully Reset Password with 123456.',
              color: 'success',
              position: 'top-right'
            });
          }

        });
      },
      async changeMobo(id, mobileNo) {
        const changeMb = {
          id: id,
          data: {
            phone: mobileNo
          }
        };
        console.log("ID", id);
        this.popupActivo = false;
        await this.$store.dispatch('updateApplicant', changeMb);
        await this.$store.dispatch('getApplicantList', 'applicants?status=1&page=' + this.selectedPgae);
      },
      deleteUser(user){
        this.popupActivForDelete = true;
        this.selectedUser = user;
      },
      confirmDelete(user){
        this.popupActivForDelete = false;
        this.$store.dispatch('deleteUser', user);
      },
      serachActiveApplicant(data) {
        const param = `applicants?status=1&page=${this.selectedPgae}&search=${data}`;
        this.$store.dispatch('getApplicantList', param);
      },

      showMbChangePopup(id, phone) {
        this.popupActivo = true;
        this.selectedId = id;
        console.log(id);
        console.log(phone);
      },
      showPassresetPopup(id) {
        this.popupActivForPassReset = true;
        this.passResetId = id;
      },
      onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
    }
  }
</script>
